// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file bundles/v1/common.proto (package bundles.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bundles/v1/common.proto.
 */
export const file_bundles_v1_common: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChdidW5kbGVzL3YxL2NvbW1vbi5wcm90bxIKYnVuZGxlcy52MSIdCgVQb2ludBIJCgF4GAEgASgCEgkKAXkYAiABKAIiWAoFTWVkaWESIgoFaW1hZ2UYASABKAsyES5idW5kbGVzLnYxLkltYWdlSAASIgoFdmlkZW8YAiABKAsyES5idW5kbGVzLnYxLlZpZGVvSABCBwoFdmFsdWUidQoFSW1hZ2USCwoDdXJsGAEgASgJEhUKCGFsdF90ZXh0GAIgASgJSACIAQESKwoLZm9jYWxfcG9pbnQYAyABKAsyES5idW5kbGVzLnYxLlBvaW50SAGIAQFCCwoJX2FsdF90ZXh0Qg4KDF9mb2NhbF9wb2ludCIoCgtWaWRlb1NvdXJjZRILCgN1cmwYASABKAkSDAoEdHlwZRgCIAEoCSJUCgVWaWRlbxIPCgdzb3VyY2VzGAEgAygJEigKDXByZXZpZXdfaW1hZ2UYAiABKAsyES5idW5kbGVzLnYxLkltYWdlEhAKCGF1dG9wbGF5GAMgASgIIoUCCgtHZW9Mb2NhdGlvbhIQCghsYXRpdHVkZRgBIAEoAhIRCglsb25naXR1ZGUYAiABKAISEAoIdGltZXpvbmUYAyABKAkSFgoOY29udGluZW50X2NvZGUYBCABKAkSEwoLY291bnRyeV9pc28YBSABKAkSGAoQc3ViZGl2aXNpb24xX2lzbxgGIAEoCRIYChBzdWJkaXZpc2lvbjJfaXNvGAcgASgJEgwKBGNpdHkYCCABKAkSEgoKbWV0cm9fY29kZRgJIAEoCRITCgtwb3N0YWxfY29kZRgKIAEoCRIOCgZyZWdpb24YDCABKAkSFwoPYWNjdXJhY3lfbWV0ZXJzGAsgASgBYgZwcm90bzM",
	);

/**
 * Point is used to define where an object is placed visually in a user expience, i.e. the Builder experience.
 *
 * @generated from message bundles.v1.Point
 */
export type Point = Message<"bundles.v1.Point"> & {
	/**
	 * @generated from field: float x = 1;
	 */
	x: number;

	/**
	 * @generated from field: float y = 2;
	 */
	y: number;
};

/**
 * Point is used to define where an object is placed visually in a user expience, i.e. the Builder experience.
 *
 * @generated from message bundles.v1.Point
 */
export type PointJson = {
	/**
	 * @generated from field: float x = 1;
	 */
	x?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float y = 2;
	 */
	y?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message bundles.v1.Point.
 * Use `create(PointSchema)` to create a new message.
 */
export const PointSchema: GenMessage<Point, { jsonType: PointJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_common, 0);

/**
 * Media is a message that represents the media that is associated with an asset.
 *
 * @generated from message bundles.v1.Media
 */
export type Media = Message<"bundles.v1.Media"> & {
	/**
	 * @generated from oneof bundles.v1.Media.value
	 */
	value:
		| {
				/**
				 * @generated from field: bundles.v1.Image image = 1;
				 */
				value: Image;
				case: "image";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Video video = 2;
				 */
				value: Video;
				case: "video";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * Media is a message that represents the media that is associated with an asset.
 *
 * @generated from message bundles.v1.Media
 */
export type MediaJson = {
	/**
	 * @generated from field: bundles.v1.Image image = 1;
	 */
	image?: ImageJson;

	/**
	 * @generated from field: bundles.v1.Video video = 2;
	 */
	video?: VideoJson;
};

/**
 * Describes the message bundles.v1.Media.
 * Use `create(MediaSchema)` to create a new message.
 */
export const MediaSchema: GenMessage<Media, { jsonType: MediaJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_common, 1);

/**
 * Image allows the display of images with alt text for accessability and SEO best practices.
 *
 * @generated from message bundles.v1.Image
 */
export type Image = Message<"bundles.v1.Image"> & {
	/**
	 * Url is the fully qualified url of the image.
	 *
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * Alternate text to display with the img tag.
	 *
	 * @generated from field: optional string alt_text = 2;
	 */
	altText?: string | undefined;

	/**
	 * Focal point on the image.
	 *
	 * @generated from field: optional bundles.v1.Point focal_point = 3;
	 */
	focalPoint?: Point | undefined;
};

/**
 * Image allows the display of images with alt text for accessability and SEO best practices.
 *
 * @generated from message bundles.v1.Image
 */
export type ImageJson = {
	/**
	 * Url is the fully qualified url of the image.
	 *
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * Alternate text to display with the img tag.
	 *
	 * @generated from field: optional string alt_text = 2;
	 */
	altText?: string;

	/**
	 * Focal point on the image.
	 *
	 * @generated from field: optional bundles.v1.Point focal_point = 3;
	 */
	focalPoint?: PointJson;
};

/**
 * Describes the message bundles.v1.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image, { jsonType: ImageJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_common, 2);

/**
 * @generated from message bundles.v1.VideoSource
 */
export type VideoSource = Message<"bundles.v1.VideoSource"> & {
	/**
	 * Url is the fully qualified url of the video.
	 *
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * Type is the type of video source, ex. video/mp4
	 *
	 * @generated from field: string type = 2;
	 */
	type: string;
};

/**
 * @generated from message bundles.v1.VideoSource
 */
export type VideoSourceJson = {
	/**
	 * Url is the fully qualified url of the video.
	 *
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * Type is the type of video source, ex. video/mp4
	 *
	 * @generated from field: string type = 2;
	 */
	type?: string;
};

/**
 * Describes the message bundles.v1.VideoSource.
 * Use `create(VideoSourceSchema)` to create a new message.
 */
export const VideoSourceSchema: GenMessage<VideoSource, { jsonType: VideoSourceJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_common, 3);

/**
 * @generated from message bundles.v1.Video
 */
export type Video = Message<"bundles.v1.Video"> & {
	/**
	 * The set of video sorces for this video.
	 *
	 * @generated from field: repeated string sources = 1;
	 */
	sources: string[];

	/**
	 * Image to disply as a preview of the video.
	 *
	 * @generated from field: bundles.v1.Image preview_image = 2;
	 */
	previewImage?: Image | undefined;

	/**
	 * Whether the video should autoplay.
	 *
	 * @generated from field: bool autoplay = 3;
	 */
	autoplay: boolean;
};

/**
 * @generated from message bundles.v1.Video
 */
export type VideoJson = {
	/**
	 * The set of video sorces for this video.
	 *
	 * @generated from field: repeated string sources = 1;
	 */
	sources?: string[];

	/**
	 * Image to disply as a preview of the video.
	 *
	 * @generated from field: bundles.v1.Image preview_image = 2;
	 */
	previewImage?: ImageJson;

	/**
	 * Whether the video should autoplay.
	 *
	 * @generated from field: bool autoplay = 3;
	 */
	autoplay?: boolean;
};

/**
 * Describes the message bundles.v1.Video.
 * Use `create(VideoSchema)` to create a new message.
 */
export const VideoSchema: GenMessage<Video, { jsonType: VideoJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_common, 4);

/**
 * GeoLocation represents a location captured from a device
 * with GeoLocation capabilities that may have been hydrated
 * with additional information
 *
 * @generated from message bundles.v1.GeoLocation
 */
export type GeoLocation = Message<"bundles.v1.GeoLocation"> & {
	/**
	 * @generated from field: float latitude = 1;
	 */
	latitude: number;

	/**
	 * @generated from field: float longitude = 2;
	 */
	longitude: number;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone: string;

	/**
	 * @generated from field: string continent_code = 4;
	 */
	continentCode: string;

	/**
	 * @generated from field: string country_iso = 5;
	 */
	countryIso: string;

	/**
	 * @generated from field: string subdivision1_iso = 6;
	 */
	subdivision1Iso: string;

	/**
	 * @generated from field: string subdivision2_iso = 7;
	 */
	subdivision2Iso: string;

	/**
	 * @generated from field: string city = 8;
	 */
	city: string;

	/**
	 * @generated from field: string metro_code = 9;
	 */
	metroCode: string;

	/**
	 * @generated from field: string postal_code = 10;
	 */
	postalCode: string;

	/**
	 * @generated from field: string region = 12;
	 */
	region: string;

	/**
	 * @generated from field: double accuracy_meters = 11;
	 */
	accuracyMeters: number;
};

/**
 * GeoLocation represents a location captured from a device
 * with GeoLocation capabilities that may have been hydrated
 * with additional information
 *
 * @generated from message bundles.v1.GeoLocation
 */
export type GeoLocationJson = {
	/**
	 * @generated from field: float latitude = 1;
	 */
	latitude?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float longitude = 2;
	 */
	longitude?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone?: string;

	/**
	 * @generated from field: string continent_code = 4;
	 */
	continentCode?: string;

	/**
	 * @generated from field: string country_iso = 5;
	 */
	countryIso?: string;

	/**
	 * @generated from field: string subdivision1_iso = 6;
	 */
	subdivision1Iso?: string;

	/**
	 * @generated from field: string subdivision2_iso = 7;
	 */
	subdivision2Iso?: string;

	/**
	 * @generated from field: string city = 8;
	 */
	city?: string;

	/**
	 * @generated from field: string metro_code = 9;
	 */
	metroCode?: string;

	/**
	 * @generated from field: string postal_code = 10;
	 */
	postalCode?: string;

	/**
	 * @generated from field: string region = 12;
	 */
	region?: string;

	/**
	 * @generated from field: double accuracy_meters = 11;
	 */
	accuracyMeters?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message bundles.v1.GeoLocation.
 * Use `create(GeoLocationSchema)` to create a new message.
 */
export const GeoLocationSchema: GenMessage<GeoLocation, { jsonType: GeoLocationJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_common, 5);
